import cx from 'classnames';
import React from 'react';

import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import AlarmIcon from '@material-ui/icons/Notifications';

import styles from './Alert.module.scss';

type AlertType = 'alert' | 'info' | 'error';

export type AlertProps = {
  /** Controls the icon that is shown next to the message */
  type: AlertType;
  /** The message to show to the user */
  message: string;
  /** This is where you would pass any buttons or other interactive elements, if needed. */
  callToActionChildren?: React.ReactNode;
  'data-testid'?: string;
};

function mapTypeToIcon(type: AlertType) {
  switch (type) {
    case 'info':
      return <InfoIcon aria-label="Information" />;
    case 'alert':
      return <AlarmIcon aria-label="Alert" />;
    case 'error':
      return <ErrorIcon aria-label="Error" />;
  }
}

export const Alert: React.FC<AlertProps> = (props: AlertProps) => {
  const { type, message, callToActionChildren } = props;
  return (
    <div
      className={cx(styles.notice, type === 'alert' && styles.noticeAlert)}
      role="status"
      data-testid={props['data-testid']}
    >
      <div className={styles.messageContainer}>
        {mapTypeToIcon(type)}
        <Typography variant="body2">{message}</Typography>
      </div>
      <div className={styles.callToActionChildren}>{callToActionChildren}</div>
    </div>
  );
};
